export default {
  woundPain: {
    painParameterList: [],
    selectedPain: '',
  },
};
